import { useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { PermissionEnum, TransactionLogsContent } from '@ui/src';
import { useAppSelector } from '@store';
import { useLazyGetCustomersTransactionLogsQuery } from '../store/services/customers';

const ProblemInternalTransactionLogContentHOC = (): React.JSX.Element => {
  const { transactionId } = useParams();

  const {
    customersProblemTransactions: {
      internal: { logs },
    },
    customersDictionaries: { activePermissions },
  } = useAppSelector((state) => state);

  const [getInternalLogs, { isLoading }] =
    useLazyGetCustomersTransactionLogsQuery();

  const getInternalLogsAction = useCallback(() => {
    getInternalLogs(transactionId as string);
  }, [transactionId]);

  useEffect(() => {
    if (!logs && transactionId) {
      getInternalLogsAction();
    }
  }, [getInternalLogsAction, logs, transactionId]);

  return (
    <TransactionLogsContent
      isLoading={isLoading}
      logs={logs}
      activePermission={activePermissions?.includes(
        PermissionEnum.TRANSACTION_QUEUE_ITEMS_INTERNAL_LIST,
      )}
    />
  );
};

export default ProblemInternalTransactionLogContentHOC;
